import React, { memo, FC } from "react";
import Selection from "./Selection/Selection";
import ReusableAccordian from "./ReusableAccordion";
import { RowLayout } from "../util/accordianStyles";

const QuantityAccordian: FC = () => {
  return (
    <ReusableAccordian
      accordionName="quantity"
      heading="Quantity"
      secondaryHeading="Select a quantity"
    >
      <RowLayout>
        <Selection typeRequired={"quantity"} />
      </RowLayout>
    </ReusableAccordian>
  );
};

export default memo(QuantityAccordian);
